import { render } from "./MetricsViewer.vue?vue&type=template&id=0ea3d3c4&scoped=true&ts=true"
import script from "./MetricsViewer.vue?vue&type=script&lang=ts"
export * from "./MetricsViewer.vue?vue&type=script&lang=ts"

import "./MetricsViewer.vue?vue&type=style&index=0&id=0ea3d3c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea3d3c4"]])

export default __exports__